module.exports = __webpack_public_path__ + "img/benefits01-02.d946152.png";